// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--3mBiF";
export var icons = "Footer-module--icons--2dm8w";
export var gameIcon = "Footer-module--game-icon--FGhWm";
export var importantInfo = "Footer-module--important-info--8PUFz";
export var usefulLinks = "Footer-module--useful-links--2ZHCM";
export var link = "Footer-module--link--2LsB4";
export var copyrights = "Footer-module--copyrights--1ZR78";
export var monopolyText = "Footer-module--monopoly-text--1EzCK";